module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId])
      /******/
      return installedModules[moduleId].exports;
    /******/
    // Create a new module (and put it into the cache)

    /******/

    var module = installedModules[moduleId] = {
      /******/
      exports: {},

      /******/
      id: moduleId,

      /******/
      loaded: false
      /******/

    };
    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    // Flag the module as loaded

    /******/

    module.loaded = true;
    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/
  // __webpack_public_path__

  /******/

  __webpack_require__.p = "";
  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(0);
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  0:
  /***/
  function _(module, exports, __webpack_require__) {
    __webpack_require__(954);

    module.exports = __webpack_require__(954);
    /***/
  },

  /***/
  3:
  /***/
  function _(module, exports) {
    module.exports = function () {
      throw new Error("define cannot be used indirect");
    };
    /***/

  },

  /***/
  20:
  /***/
  function _(module, exports) {
    module.exports = require("../kendo.core");
    /***/
  },

  /***/
  954:
  /***/
  function _(module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    (function (f, define) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = f, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    })(function () {
      (function ($) {
        /* jshint proto: true */
        function createPromise() {
          return $.Deferred();
        }

        function promiseAll(promises) {
          return $.when.apply($, promises);
        }

        function extendStatic(dest, src) {
          if (!src) {
            return;
          }

          if (typeof src.__proto__ === 'function') {
            dest.__proto__ = src;
          } else {
            for (var member in src) {
              if (src.hasOwnProperty(member)) {
                dest[member] = src[member];
              }
            }
          }
        }

        kendo.drawing.util = kendo.drawing.util || {};
        kendo.deepExtend(kendo.drawing.util, {
          createPromise: createPromise,
          promiseAll: promiseAll,
          extendStatic: extendStatic
        });
      })(window.kendo.jQuery);

      return window.kendo;
    }, __webpack_require__(3));
    /***/

  }
  /******/

});